<template>
  <div>
    <transition name="modal-transition">
      <div v-if="showModal" class="modal" :class="{ show: showModal }">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">แบบยินยอมจัดเก็บข้อมูลส่วนบุคคล</h5>
              <button type="button" class="btn-close" @click="closeModal" aria-hidden="true"></button>
            </div>
            <div class="modal-body">
              <p> มหาวิทยาลัยทักษิณมีความจำเป็นในการจัดเก็บข้อมูลส่วนตัวของผู้บริจาคเพื่อนำไปใช้ในการการออกใบเสร็จและลดหย่อนภาษีให้กับท่าน หากท่านต้องการบริจาคถือว่าท่านได้ยอมรับ นโยบายความเป็นส่วนตัว ฉบับนี้แล้ว</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" @click="closeModal">ปิด</button>
              <button type="button" class="btn btn-success" @click="acceptCookies">ยินยอม</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useCookies } from 'vue3-cookies';

const { cookies } = useCookies();
const showModal = ref(false);

const closeModal = () => {
  showModal.value = false;
};

const acceptCookies = () => {
  cookies.set('aceptPrivacy', '1');
  showModal.value = false;
};

onMounted(() => {
  showModal.value = cookies.get('aceptPrivacy') !== '1';
});
</script>

<style scoped>
.modal {
  display: none;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}

.modal.show {
  display: block;
}

.modal-dialog {
  max-width: 500px;
  margin: 10% auto;
  background: #fff;
  border-radius: 4px;
}

.modal-header,
.modal-body,
.modal-footer {
  padding: 15px;
}

.modal-title {
  margin-top: 0;
}

.modal-footer {
  border-top: 1px solid #e9e9e9;
  text-align: right;
}

.modal-transition-enter-active {
  transition: all 0.3s ease-out;
}
.modal-transition-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.modal-transition-enter-from,
.modal-transition-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>